import { Box, Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';

const UserAntipassbackView = ({ data }) => {
  const { details } = data || {};
  const apbEnabled = details?.[0]?.apb;
  const hardAlert = details?.[0]?.hardAlert;
  const alertType = hardAlert ? 'hard' : 'soft';

  const { t } = useTranslation('admin', { keyPrefix: 'property.users' });

  return (
    <Box sx={{ p: 2 }}>
      <FormControlLabel
        control={<Checkbox checked={apbEnabled} color="primary" disabled name="enableAntipassback" readOnly />}
        label={t('antiPassback.enable')}
      />

      {apbEnabled && (
        <Box sx={{ mt: 3 }}>
          <FormControl sx={{ minWidth: 200 }} variant="outlined">
            <InputLabel id="alertType-label">{t('antiPassback.type')}</InputLabel>
            <Select disabled id="alertType" label={t('antiPassback.type')} labelId="alertType-label" readOnly value={alertType}>
              <MenuItem value="soft">{t('antiPassback.soft')}</MenuItem>
              <MenuItem value="hard">{t('antiPassback.hard')}</MenuItem>
            </Select>
          </FormControl>
        </Box>
      )}
    </Box>
  );
};

export default UserAntipassbackView;
